export const ApiUrl = {
  uploadUrl: 'https://beiji-api.30days-tech.com/bj/manager/common/upload',  //后端本地

  // uploadUrl: 'http://test.api.zzmovi.com/ztb2c/manager/common/upload',

  // uploadUrl: 'http://api.zzmovi.com/ztb2c/manager/common/upload',
}